import { render } from "./autonimyProposal.vue?vue&type=template&id=53288bbf&scoped=true"
import script from "./autonimyProposal.vue?vue&type=script&lang=js"
export * from "./autonimyProposal.vue?vue&type=script&lang=js"

import "./autonimyProposal.vue?vue&type=style&index=0&id=53288bbf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53288bbf"]])

export default __exports__